// Super admin ima sve sto i admin, plus upravljanje admin nalozima.
export const isSuperAdmin = (user) => user?.role === 'superadmin';

export const isAdmin = (user) =>
  user?.role === 'admin' || user?.role === 'superadmin';

// Svi nalozi osoblja apoteke (admin, super admin, apoteka).
export const isStaff = (user) => isAdmin(user) || user?.role === 'pharmacy';

// Admin nalozi nemaju email; prikazuju se kao @ime.prezime.
export const formatUsername = (username) => (username ? `@${username}` : '');
